import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ContractConfigColor, Pagination } from '../models';
import { BaseApiService } from './baseApiService';
import { StorageKey } from './storage.service';

@Injectable({
  providedIn: 'root'
})

export class ContractConfigColorService extends BaseApiService<ContractConfigColor> {
  get cacheKey(): StorageKey {
    return StorageKey.contractServiceCache;
  }

  getUrl(operation: string, params, id: string = null): string {
    let url = `${environment.omniaCoreApiUrl}/v1/contract/configColor`;
    if (id != null) {
      url = url + '/' + encodeURIComponent(id);
    }
    return url;
  }

  removeContractConfigColor(contractId: number, colorId: number) {
    const url = `${environment.omniaCoreApiUrl}/v1/contract/configColor/${encodeURIComponent(contractId)}/${encodeURIComponent(colorId)}`;
    return this.http.delete(url).pipe().toPromise();
  }

  protected unparse(obj) {
    return ContractConfigColor.unparse(obj);
  }

  protected parse(obj) {
    return ContractConfigColor.parse(obj);
  }
}
